import { createSelector } from "reselect";

import getFilter from "../base_getters/get_filter";

import type { TradesFilterStore } from "../../reducers/filter/reduce_trades_filter";

const getTradesFilter = createSelector([
  getFilter
], (filter) => {
  return filter.trades || {} as TradesFilterStore;
});

export default getTradesFilter;
